<div class="protocolo-log-dialog__overlay" (click)="onClose()">
  <div
    class="protocolo-log-dialog"
    role="dialog"
    aria-modal="true"
    aria-labelledby="protocolo-log-dialog-title"
    data-testid="protocolo-log-dialog"
    (click)="$event.stopPropagation()"
  >
    <h2 id="protocolo-log-dialog-title" class="protocolo-log-dialog__title">
      Log de protocolo
    </h2>

    <dl class="protocolo-log-dialog__fields">
      <dt>Nome</dt>
      <dd data-testid="protocolo-nome">{{ adesao().nome }}</dd>

      <dt>Matrícula</dt>
      <dd data-testid="protocolo-matricula">{{ adesao().matricula ?? '—' }}</dd>

      <dt>Status</dt>
      <dd data-testid="protocolo-status">{{ adesao().status }}</dd>

      <dt>Nº Protocolo de Solicitação</dt>
      <dd data-testid="protocolo-num-solicitacao">{{ adesao().numProtocoloSolicitacao ?? '—' }}</dd>

      <dt>Data da Solicitação</dt>
      <dd data-testid="protocolo-data-solicitacao">
        {{ formatProtocoloData(adesao().dataProtocoloSolicitacao) }}
      </dd>

      @if (adesao().numProtocoloCancelamento) {
        <dt>Nº Protocolo de Cancelamento</dt>
        <dd data-testid="protocolo-num-cancelamento">{{ adesao().numProtocoloCancelamento }}</dd>

        <dt>Data do Cancelamento</dt>
        <dd data-testid="protocolo-data-cancelamento">
          {{ formatProtocoloData(adesao().dataProtocoloCancelamento) }}
        </dd>
      }
    </dl>

    <div class="protocolo-log-dialog__actions">
      <button
        type="button"
        class="btn-primary"
        data-testid="protocolo-log-dialog-fechar"
        (click)="onClose()"
      >
        Fechar
      </button>
    </div>
  </div>
</div>
